module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTM2OC44IDk3MC43IDQ0LjYgOTcwLjdsMzA5LjgtNDU3LjZMNzMuMiA5My42bDMyNC4xIDAgMTIzLjkgMjI0IDEyOC43LTIyNCAzMjQuMSAwTDY3My44IDUxMy4xbDMwMC4zIDQ1Ny42TDY1MCA5NzAuNyA1MTEuOCA3MjIuOCAzNjguOCA5NzAuN3oiIGZpbGw9IiMyMzE4MTUiIHAtaWQ9IjYxNyI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/x.svg
// module id = HZo+
// module chunks = 74